import Vue from 'vue';

export const Toast = {
    success: (data) =>
    {
        let form = {
            icon: 'fa fa-check',
            title: data.title,
            message: data.message,
            type: 'vh-toast-success',
        };

        Toast.fire(form);
    },

    error: (data) =>
    {
        let form = {
            icon: 'fa fa-exclamation',
            title: data.title,
            message: data.message,
            type: 'vh-toast-danger',
        };

        Toast.fire(form);
    },

    fire: (data) =>
    {
        Vue.notify({
            group: 'notification',
            title: data.title,
            text: data.message,
            type: data.type,
            closeOnClick: true,
        });
        // $.notify({
        //     icon: data.icon,
        //     title: data.title,
        //     message: data.message,
        // },{
        //     type: data.type,
        //     placement: {
        //         from: data.from || 'bottom',
        //         align: data.align || 'right'
        //     },
        //     time: data.time || 1000,
        // });
    },
};



// WEBPACK FOOTER //
// ./src/utils/toast.js